import { render } from "./AddEditNotPbMajor.vue?vue&type=template&id=0b7295fa&scoped=true"
import script from "./AddEditNotPbMajor.vue?vue&type=script&lang=js"
export * from "./AddEditNotPbMajor.vue?vue&type=script&lang=js"

import "./AddEditNotPbMajor.vue?vue&type=style&index=0&id=0b7295fa&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7295fa"]])

export default __exports__